<template>
  <el-form
    class="access-strategy-form form-dia-container"
:class="{ 'dark' : skinType }"
    ref="accessStrategyForm"
    :model="form"
    label-width="120px"
  >
    <el-form-item label="策略类型:">
      <el-switch v-model="form.F_Type"   active-text="允许访问"
        inactive-text="拒绝访问"></el-switch>
    </el-form-item>
    <el-form-item label="起始IP:">
      <el-input v-model="form.F_StartIP"></el-input>
    </el-form-item>
    <el-form-item label="结束IP:">
      <el-input v-model="form.F_EndIP"></el-input>
    </el-form-item>
    <el-form-item label="是否有效:">
      <el-switch v-model="form.F_EnabledMark"></el-switch>
    </el-form-item>
    <el-form-item label="备注:">
      <el-input type="textarea" v-model="form.Remark"></el-input>
    </el-form-item>
    <el-form-item size="small">
      <el-button type="primary" @click="onSubmit">确认</el-button>
      <el-button @click="emitCloseDialog">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { addStrategy } from '@/api/system-safety/index';
import { convertDataToFormData } from '@/utils/utils';
import DiaFromMixin from '@/components/operating-maintenance/mixins/dia-form-mixin';

export default {
  name: 'access-strategy',
  props: {
    selectAccessStategy: {
      type: Object,
      default() {
        return {};
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [DiaFromMixin],
  data() {
    return {
      dialogVisible: false,
      form: {
        TabID: null,
        F_Type: false,
        F_EnabledMark: false,
        F_StartIP: '',
        F_EndIP: '',
        Remark: '',
      },
    };
  },
  created() {
    this.initialDataFromProp(this.form, this.selectAccessStategy);
  },
  watch: {
    selectAccessStategy() {
      this.initialDataFromProp(this.form, this.selectAccessStategy);
    },
    form: {
      deep: true,
    },
  },
  methods: {
    onSubmit() {
      const formData = convertDataToFormData(this.form);
      addStrategy(formData, { keyValue: this.form.F_Id }).then(() => {
        this.notifyDataChanged();
        this.emitCloseDialog();
      }).catch(() => {
        this.initialDataFromProp(this.form, this.selectAccessStategy);
      });
    },
  },
};
</script>
